import styled from "styled-components";
import TextGothic from "components/utils/TextGothic";
import { PlacelistType } from "resources/placelists";
import { media, useSpQuery } from "utils/media";
import { theme } from "utils/theme";

type Props = {
  placelist: PlacelistType;
};

const Top = (props: Props) => {
  const { placelist } = props;
  const isSp = useSpQuery();

  return (
    <Wrapper>
      <Box>
        <ArtistImg
          src={`/domtour/theme/workation/music/images/${placelist.id}/artist.jpg`}
          alt="artist"
        />
        <Title>
          <div>
            <TextGothic size={isSp ? "20px" : "28px"} lh={1.5} as="h1">
              {placelist.title}
            </TextGothic>
            <Composer>
              Composed by{" "}
              <Name size="16px" lh={1.5}>
                {placelist.artists.join("、")}
              </Name>
            </Composer>
          </div>
        </Title>
      </Box>
      <Content>{placelist.content}</Content>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  position: relative;
`;

const Box = styled.div`
  position: relative;
`;

const ArtistImg = styled.img`
  vertical-align: top;
  ${media.sp`
    position: relative;
    height: calc(100vw * ${theme.spArtistImgAspect});
  `}
  ${media.pc`
    max-width: 950px;
    height: 450px;
    display: block;
    margin: 0 auto;
  `}
  width: 100%;
  object-fit: cover;
  font-family: "object-fit: cover;";
`;

const Title = styled.div`
  position: relative;
  ${media.sp`
    padding: 16px 20px 16px;
  `}
  ${media.pc`
    box-sizing: content-box;
    background: #fff;
    width: 715px;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    bottom: 0;
    padding: 12px 20px;
  `}
`;

const Composer = styled.div`
  font-size: 14px;
  ${media.sp`
    margin: 8px 0;
  `}
  ${media.pc`
    margin-top: 4px;
  `}
`;

const Name = styled(TextGothic)`
  display: inline-block;
`;

const Content = styled.div`
  ${media.sp`
    padding: 0 20px 48px;
  `}
  ${media.pc`
    width: 715px;
    margin: 0 auto;
    padding: 48px 0;
  `}
`;

export default Top;
